export default "__VITE_ASSET__DbXvPkwV__"